<mat-card>
    <mat-card-header>
        <mat-card-title>Veto Settings</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form [formGroup]="vetoSettingsGroup"> // Change to Add Table (Sorted by Name) with checkbox for default
            <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                <mat-label>Default Map Pool</mat-label>
                <mat-select [formControl]="vetoSettingsGroup.controls.mapPoolControl" multiple>
                    <mat-option value="Abyss">Abyss</mat-option>
                    <mat-option value="Ascent">Ascent</mat-option>
                    <mat-option value="Bind">Bind</mat-option>
                    <mat-option value="Breeze">Breeze</mat-option>
                    <mat-option value="Corrode">Corrode</mat-option>
                    <mat-option value="Fracture">Fracture</mat-option>
                    <mat-option value="Haven">Haven</mat-option>
                    <mat-option value="Icebox">Icebox</mat-option>
                    <mat-option value="Lotus">Lotus</mat-option>
                    <mat-option value="Pearl">Pearl</mat-option>
                    <mat-option value="Split">Split</mat-option>
                    <mat-option value="Sunset">Sunset</mat-option>
                </mat-select>
            </mat-form-field>                               
        </form>
    </mat-card-content>
</mat-card>
